import moment from 'moment';
import { IN_PERSON_TRAINING } from 'constants/actionTypes';

const initialState = {
  contentItems: [],
  contentItemsErrors: [],
  loading: true,
  error: null,
};

export default (state = initialState, action) => {
  const updateState = changes => ({ ...state, ...changes });
  switch (action.type) {
    case IN_PERSON_TRAINING.ASSOCIATED_CONTENT.DATA_REQUEST:
      return updateState({ loading: true, error: null });

    case IN_PERSON_TRAINING.ASSOCIATED_CONTENT.DATA_FAILURE:
      return updateState({ loading: false, error: action.payload });

    case IN_PERSON_TRAINING.ASSOCIATED_CONTENT.DATA_SUCCESS:
      return updateState({ contentItems: action.payload, loading: false });

    case IN_PERSON_TRAINING.ASSOCIATED_CONTENT.SET_ACTION_MESSAGE:
      if (!action.payload) {
        return updateState({
          actionMessage: null,
        });
      }

      return updateState({
        actionMessage: action.payload,
      });

    case IN_PERSON_TRAINING.ASSOCIATED_CONTENT.ADD_ITEM: {
      if (!action.payload) {
        return state;
      }

      return {
        ...state,
        contentItems: state.contentItems.concat(action.payload),
      };
    }

    case IN_PERSON_TRAINING.ASSOCIATED_CONTENT.REMOVE_ITEM: {
      const itemToRemove = state.contentItems.findIndex(
        item => item.association_id === action.payload,
      );

      if (itemToRemove < 0) return state;

      return {
        ...state,
        contentItems: [
          ...state.contentItems.slice(0, itemToRemove),
          ...state.contentItems.slice(itemToRemove + 1),
        ],
      };
    }

    case IN_PERSON_TRAINING.ASSOCIATED_CONTENT.REMOVE_FAILURE:
      if (
        state.contentItemsErrors.find(
          error => error.associationId === action.payload.associationId,
        )
      ) {
        return state;
      }

      return {
        ...state,
        contentItemsErrors: [
          ...state.contentItemsErrors,
          {
            associationId: action.payload.associationId,
            error: action.payload.error,
          },
        ],
      };

    case IN_PERSON_TRAINING.ASSOCIATED_CONTENT.ASSIGN_CONTENT:
      if (
        state.contentItems.every(item => item.assigned_at) ||
        action.payload
      ) {
        return state;
      }

      return {
        ...state,
        contentItems: state.contentItems.map(item => ({
          ...item,
          assigned_at: moment().format(),
        })),
      };

    default:
      return state;
  }
};
